export default __webpack_public_path__ + "static/media/warning-circle.46e27a82.svg";